<template>
  <div class="member">
    <van-nav-bar title="会员管理" left-arrow @click-left="onClickLeft" />
    <div class="memberHeader">
      <img
        src="@/assets/images/member_02.png"
        alt=""
        width="100%"
        height="auto"
      />
    </div>
    <div class="griddiv">
      <div
        class="card"
        @click="$router.push({ path: '/puhui/services/member/join' })"
      >
        <img class="icon" src="@/assets/images/h1-01.png" />
        <div class="cardtitle">入会指南</div>
      </div>
      <div
        class="card"
        @click="$router.push({ path: '/puhui/services/member/do' })"
      >
        <img class="icon" src="@/assets/images/h2-01.png" />
        <div class="cardtitle">办理会员证指南</div>
      </div>
      <div
        class="card"
        @click="$router.push({ path: '/puhui/services/member/manage' })"
      >
        <img class="icon" src="@/assets/images/h3-01.png" />
        <div class="cardtitle">会员管理知识点</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'member',
  created() {
    let title = '会员管理';
    if (this.$getUA() === 1) {
      this.$callApp('Android', 'onJSAppSetTitle', title); //调用安卓的设置标题方法
      this.$callApp('Android', 'SetWebViewZoom', false);
    } else if (this.$getUA() === 2) {
      this.$callApp('iOS', 'getWebViewTitleMethod', title); //调用IOS设置标题的方法
      this.$callApp('iOS', 'EnableWebZoomMethod', false);
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.van-nav-bar__text {
  color: black;
  font-size: 16px;
}

.van-icon-arrow-left::before {
  color: black;
  font-size: 16px;
}

.van-nav-bar {
  line-height: 50px;
  height: 50px;
  background-color: white;
}
.griddiv {
  margin: 10px 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  align-content: space-between;
}

.icon {
  width: 40px;
  height: 40px;
}

.card {
  // border: 1px solid red;
  display: flex;
  align-items: center;
  flex-basis: 49%;
  margin: 5px 0px;
}

.cardtitle {
  font-size: 14px;
  margin-left: 5px;
}
</style>
